// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'picture-solid';

export const Component = () => (
  <path
    fill='currentColor'
    stroke='currentColor'
    strokeLinecap='round'
    strokeLinejoin='round'
    d='M13.518.563c.293 0 .575.114.785.319l2.216 2.162a1.129 1.129 0 0 1 .338.806v12.462a1.125 1.125 0 0 1-1.125 1.125H2.268a1.126 1.126 0 0 1-1.125-1.125V1.688A1.126 1.126 0 0 1 2.268.563zm-3.123 7.829c-.38.04-.685.263-.905.576l-1.694 2.409-.834-.665-.018-.015-.018-.012-.122-.074a1.27 1.27 0 0 0-.932-.138c-.36.09-.636.338-.834.637L3.03 14.15h11.997l-3.51-5.326-.052-.079-.078-.055c-.285-.2-.626-.338-.991-.298zm-4.19-4.954c-.507 0-.997.176-1.387.495l-.16.145a2.188 2.188 0 0 0 0 3.094l.16.145c.39.32.88.495 1.387.495l.216-.01c.5-.05.972-.271 1.331-.63l.145-.16a2.189 2.189 0 0 0 0-2.774l-.145-.16c-.36-.359-.83-.58-1.331-.63z'
  />
);

export const viewBox = '0 0 18 18';
